<template>
    <l-layer-group
        :layer-type="overlay.type"
        v-model:visible="overlay_visible"
        :name="(overlay.name)"
        ref="tracksLayer"
        @ready="onReady()"
    >
        <l-feature-group
            ref="trackCluster"
            id="track-cluster"
        ></l-feature-group>
        <l-feature-group
            ref="trackPathLayer"
            id="track-path-layer"
        ></l-feature-group>
        <l-feature-group
            ref="moveOnTrackLayer"
            id="move-on-track"
        ></l-feature-group>
    </l-layer-group>
</template>

<script>
import {movingMarker as L_movingMarker} from "@/components/app/map/MovingMarker";
import {LFeatureGroup, LLayerGroup} from "@vue-leaflet/vue-leaflet";
import {mapGetters} from "vuex";
import {toRaw} from "vue";
import debounce from "lodash/debounce";

const validPictures = Object.freeze(
    [
        'map__pin-event',
        'map__pin-a-point',
        'map__pin-b-point',
        'map__pin-lost-connection',
        'map__pin-low-battery',
        'map__pin-max-speed',
        'map__pin-parking',
        'map__pin-shock',
        'map__pin-stop',
        'map__pin-turn',
    ])

export default {
    name: "SectionMap_layer_tracks",
    emits: ['update:modelValue'],
    mixins: [],
    inject: ['L', 'unitIcon', 'createMarker', 'mapLeafletObject', 'unitIconByType'],
    props: {
        modelValue: Object,
    },
    components: {
        LLayerGroup,
        LFeatureGroup,
    },
    data() {
        return {
            //parked: null,
            parkedLayer: null,
            parkedMarker: null,

            //track: null,
            trackControlPointsLayerClusterL: null,
            trackControlPointsLayerCluster: null,
            tracksLayer: null,
            trackEventsPointsGroup: [],
            trackLayers: null,
            trackUnitMarker: null,
            trackMarkers: [],
            trackUnitMarkerInterval: null,
            //not use
            trackDecorators: [], //use to show track direction
            trackControlPointsGroup: [],
            trackManeuversPointsGroup: [],
            trackIdlePointsGroup: [],
            // trackControlPointsLayer_options: {
            //     'clustered': {
            //         iconCreateFunction: (cluster) => {
            //
            //             let childCount = cluster.getChildCount(),
            //                 markers = cluster.getAllChildMarkers(),
            //                 totalSpeed = 0, pointCount = 0,
            //                 iconSize = [89, 52];
            //
            //             let speedUnits = (this.speedUnits);
            //
            //             let curSpeed = 0;
            //             for (let i = 0; i < markers.length; i++) {
            //                 if (markers[i].meta.type == 'control') {
            //                     curSpeed = parseInt(markers[i].meta.speed);
            //                     if (curSpeed != 0) {
            //                         totalSpeed += curSpeed;
            //                         pointCount++;
            //                     }
            //                 }
            //             }
            //             if (totalSpeed > 0) {
            //                 totalSpeed = Math.round(totalSpeed / pointCount);
            //                 totalSpeed = totalSpeed + '&nbsp;' + speedUnits;
            //             } else {
            //                 totalSpeed = '';//'-' + speedUnits;
            //             }
            //             //kmp and mph only for different length of speed string
            //             let c = ' kmp-', cc = '';
            //             if (totalSpeed.length > 13) {
            //                 c = ' mph-';
            //                 cc = 'large-';
            //                 iconSize = [101, 52];
            //             }
            //             if (!totalSpeed.length) {
            //                 c = ' ';
            //             }
            //             if (childCount < 10) {
            //                 c += 'small';
            //             } else if (childCount < 100) {
            //                 c += 'medium';
            //             } else {
            //                 c += 'large';
            //             }
            //             let speed_span = '';
            //             if (totalSpeed.length) {
            //                 speed_span = '<span class="' + cc + 'speed">' + totalSpeed + '</span>';
            //             }
            //             return new this.L.DivIcon({
            //                 html: '<div><span class="marker-count">' + childCount + '</span>' + speed_span + '</div>',
            //                 className: 'marker-cluster-track' + c,
            //                 iconSize: iconSize
            //             });
            //         }
            //     },
            //     'detailed': {
            //         iconCreateFunction: (cluster) => {
            //
            //             let //childCount = cluster.getChildCount(),
            //                 markers = cluster.getAllChildMarkers(),
            //                 options = {
            //                     html: '',
            //                     className: 'marker-cluster-track-detailed',
            //                     iconSize: [280, 32],
            //                 },
            //                 marker;
            //             let speedUnits = (this.speedUnits);
            //
            //             marker = markers.find(function (m) {
            //                 return m.meta && m.meta.type == 'parking'
            //             })
            //             if (!marker) {
            //                 marker = markers.find(function (m) {
            //                     return m.meta && m.meta.type == 'stop'
            //                 })
            //             }
            //             if (!marker) {
            //                 marker = markers.find(function (m) {
            //                     return m.meta && m.meta.type == 'control'
            //                 })
            //             }
            //             if (!marker) {
            //                 marker = markers[0]
            //             }
            //
            //             //if(this.$isDevelopment) console.log('iconCreateFunction', 'detailed', marker.meta.type, marker.meta, marker, markers)
            //
            //             if (marker && marker.meta) {
            //                 if (this.getAppUserSettings.hideMarkerTooltipForDetailedTrack) {
            //                     let color = '#' + marker.meta.color
            //                     if (marker.meta.type == 'parking') {
            //                         color = '#008CE8'
            //                     } else if (marker.meta.type == 'stop') {
            //                         color = '#FF1800'
            //                     }
            //                     //if(this.$isDevelopment) console.log(marker)
            //                     options.iconSize = [20, 20]
            //                     options.iconAnchor = [10, 10]
            //                     options.className += '-without-cluster-annotations'
            //                     options.html = '<div style="background: ' + color + ';color: ' + color + ';"></div>';
            //
            //                 } else {
            //                     options.html =
            //                         '<div>' +
            //                         '<span class="marker-time">' + marker.meta.time + '</span>' +
            //                         '<br/>' +
            //                         '<span class="marker-speed">' + marker.meta.speed + '&nbsp;' + speedUnits + '</span>' +
            //                         '</div>'
            //                     ;
            //                 }
            //             }
            //
            //             return new this.L.DivIcon(options);
            //         }
            //     },
            // },
            // trackClusterOptions: {
            //     chunkedLoading: true,
            //     removeOutsideVisibleBounds: true,
            //     spiderfyOnMaxZoom: false,
            //     showCoverageOnHover: false,
            //     zoomToBoundsOnClick: true,
            //     // maxClusterRadius: 50,
            //     disableClusteringAtZoom: 17,
            //     iconCreateFunction: (cluster) => {
            //         //return this.L.divIcon({ html: '<b>' + cluster.getChildCount() + '</b>' });
            //         let childCount = cluster.getChildCount(),
            //             // markers = cluster.getAllChildMarkers(),
            //             iconSize = [38, 38];
            //
            //         let c = ' kmp-'
            //         if (childCount < 10) {
            //             c += 'small';
            //         } else if (childCount < 100) {
            //             c += 'medium';
            //         } else {
            //             c += 'large';
            //         }
            //         return new this.L.DivIcon({
            //             html: '<div><span class="marker-count">' + childCount + '</span></div>',
            //             className: 'marker-cluster-track' + c,
            //             iconSize: iconSize,
            //             //iconAnchor: [19, 0]
            //         });
            //     }
            // },
        }
    },
    computed: {
        ...mapGetters([
            // "getAppUserSettings",
            "getTracks",
            "getParkings",
            "getStops",
            "getEvents",
            "getVideoEvents",

            "getUnitsMarkersOptionsByIds",

            "getEventsI18nMessagesByXid",
            "getVideoEventsI18nMessagesByXid",
            "getStopsI18nMessagesByXid",
        ]),
        overlay() {
            return this.modelValue
        },
        hideEvents() {
            return this.routeQueryFilter.hideEvents
        },
        eventMarkerOnTrack() {
            return {type: this.routeFilter.trackEventType, xid: this.routeFilter.trackEventXid }
        },
        unitId() {
            return this.isShowLayer ? this.routeFilter.unitId : undefined
        },
        filterDate() {
            return this.routeFilter.date
        },
        timeFrom() {
            return this.routeFilter.timeFrom
        },
        timeTo() {
            return this.routeFilter.timeTo
        },
        overlay_visible: {
            get() {
                return this.overlay?.visible
            },
            set(vl) {
                this.$emit('update:modelValue', {...this.overlay, visible: vl})
            },
        },
        isShowLayer() {
            return this.overlay?.showLayer
        },
        videoEvents() {
            let unitId = this.unitId
            let date = this.filterDate
            let timeFrom = this.timeFrom
            let timeTo = this.timeTo

            if (!timeFrom || !timeTo) return null

            let events = this.getVideoEvents
                .filter(e => {
                    return e.unit_id == unitId && e.time.date == date
                        && timeFrom <= e.time.utc && e.time.utc <= timeTo
                })
                .map(e => {
                    let message = this.getVideoEventsI18nMessagesByXid[e.xid] || e.text || ''
                    return {...e, message}
                })
            return events
        },
        updateVideoEvents() {
            return !this.track ? 0 : this.videoEvents.length
        },
        events() {
            let unitId = this.unitId
            let date = this.filterDate
            let timeFrom = this.timeFrom
            let timeTo = this.timeTo

            if (!timeFrom || !timeTo) return null

            let events = this.getEvents
                .filter(e => {
                    return e.unit_id == unitId && e.time.date == date
                        && timeFrom <= e.time.utc && e.time.utc <= timeTo
                })
                .map(e => {
                    let message = this.getEventsI18nMessagesByXid[e.xid] || e.text || ''
                    return {...e, message}
                })
            return events
        },
        updateEvents() {
            return !this.track ? 0 : this.events.length
        },
        parked() {
            let unitId = this.unitId
            let date = this.filterDate
            let timeFrom = this.timeFrom
            let timeTo = this.timeTo

            if (!timeFrom || !timeTo) return null

            let item = this.getParkings
                .find(p => {
                    return p.unit_id == unitId && p.time_start.date == date
                        && p.time_start.utc == timeFrom && p.time_end.utc == timeTo
                })
            return item || {}
        },
        stops() {
            let unitId = this.unitId
            let date = this.filterDate
            let timeFrom = this.timeFrom
            let timeTo = this.timeTo

            if (!timeFrom || !timeTo) return null

            let items = this.getStops
                .filter(s => {
                    return s.unit_id == unitId && s.time.date == date
                        && timeFrom <= s.time.utc && s.time.utc <= timeTo
                })
                .map(e => {
                    let message = this.getStopsI18nMessagesByXid[e.xid] || e.text || ''
                    return {...e, message}
                })
            return items
        },
        updateStops() {
            return !this.track ? 0 :  this.stops.length
        },
        track() {
            let unitId = this.unitId
            let date = this.filterDate
            let timeFrom = this.timeFrom
            let timeTo = this.timeTo

            if (!timeFrom || !timeTo) return null

            let track = this.getTracks
                .find(t => {
                    return t.unit_id == unitId && t.date == date
                        && t.timeFrom == timeFrom
                        && t.timeTo == timeTo
                })
            return track
        },
        trackLatLngs() {
            return this.track ? this.track.msgs.map(msg => toRaw(msg.latlng)) : []
        },
        showUnitTrackColor(){
           return !!this.routeFilter.trackColor
        },
        isUnitMoveOnTrack(){
            return !!this.routeFilter.speed
        },
        unitMoveOnTrackSpeed() {
            return +this.routeFilter.speed
        }
    },
    watch: {
        track: {
            handler: function (newTrack, oldTrack) {
                if (oldTrack || newTrack) {
                    // if(this.$isDevelopment) console.log('track', newTrack, oldTrack)
                }
                this.debouncedUpdateUnitTrack();
            },
            //deep: true
        },
        parked: {
            handler: function (newTrack, oldTrack) {
                if (oldTrack || newTrack) {
                    // if(this.$isDevelopment) console.log('track', newTrack, oldTrack)
                }
                this.debouncedUpdateUnitParked();
            },
        },
        updateStops: {
            handler: function (newTrack, oldTrack) {
                if (oldTrack || newTrack) {
                    // if(this.$isDevelopment) console.log('track', newTrack, oldTrack)
                }
                this.debouncedUpdateStopsMarkers();
            },
        },
        updateEvents: {
            handler: function (newTrack, oldTrack) {
                if (oldTrack || newTrack) {
                    // if(this.$isDevelopment) console.log('track', newTrack, oldTrack)
                }
                this.debouncedUpdateEventsMarkers();
            },
        },
        updateVideoEvents: {
            handler: function (newTrack, oldTrack) {
                if (oldTrack || newTrack) {
                    // if(this.$isDevelopment) console.log('track', newTrack, oldTrack)
                }
                this.debouncedUpdateVideoEventsMarkers();
            },
        },
        unitMoveOnTrackSpeed: {
            handler: function (newVl, oldVl) {
                // if(this.$isDevelopment) console.log('unitMoveOnTrackSpeed', newVl, oldVl)
                if (this.trackUnitMarker) {
                    this.trackUnitMarker.pause()
                    // if(this.$isDevelopment) console.log('unitMoveOnTrackSpeed', {...this.trackUnitMarker})
                    let run_time = (Date.now() - this.trackUnitMarker._startTime)
                    let duration = this.trackUnitMarker._currentDuration - run_time;
                    if (duration > 1000) {
                        duration = duration * oldVl / newVl
                        this.trackUnitMarker._currentDuration = duration + run_time
                    }
                    this.trackUnitMarker.resume()
                    // if(this.$isDevelopment) console.log('unitMoveOnTrackSpeed', {...this.trackUnitMarker})
                }
            }
        },
        showUnitTrackColor: {
            handler: function () {
                this.debouncedUpdateSpeedActive()
            },
            //deep: true
        },
        eventMarkerOnTrack: {
            handler: function (newVal, oldValue) {
                if ((newVal?.type != oldValue?.type) || (newVal?.xid != oldValue?.xid)) {
                    let group = this.trackEventsPointsGroup.filter(gr => gr.type == 'control-' + newVal.type)
                    if (!group.length || group.length > 1) {
                        console.warn('trackEventsPointsGroup - ', group)
                        return
                    }
                    let marker = group[0].layers.find(m => m.meta.xid == newVal.xid)
                    if (!marker) {
                        console.warn('trackEventsPointsGroup.layers.marker - not found')
                        return
                    }
                    setTimeout(() => marker.openPopup(), 500)
                }
            },
            deep: true
        },
        isUnitMoveOnTrack: {
            handler: function (newVal) {
                // if(this.$isDevelopment) console.log('isUnitMoveOnTrack', newVal)
                if (this.trackUnitMarkerInterval) {
                    clearInterval(this.trackUnitMarkerInterval)
                    this.trackUnitMarkerInterval = null
                }
                if (this.trackUnitMarker) {
                    this.moveOnTrackLayer.removeLayer(this.trackUnitMarker)
                    this.trackUnitMarker = null;
                }
                if (newVal) this.unitMoveOnTrack()
            },
        },
    },
    methods: {
        createTrack(trackObject, id, messages) {

            let trackLayers = [];
            trackObject.trackMessageIndexes.forEach((trackMessageIndex, sequentialIndex) => {
                let track = trackObject.tracks[sequentialIndex];
                let latlngs = messages.slice(trackMessageIndex.first, trackMessageIndex.last + 1).map(msg => msg.latlng)
                if ((trackMessageIndex.last - trackMessageIndex.first) < 1) {
                    return;
                }

                let options = {
                    color: '#' + track.color,
                    opacity: track.opacity,
                    noClip: true,
                    smoothFactor: 3,
                    weight: track.weight,
                }
                if (track.dashArray) {
                    options.dashArray = '5,10'
                }
                let trackPoly = new this.L.Polyline(latlngs, options)
                trackLayers.push(trackPoly);//ToDo ???
            });

            if (!trackLayers.length) {
                return false;
            }

            let track = {
                layer: new this.L.FeatureGroup(trackLayers),
                id: id
            };

            return track
        },
        createTrackPoints(points, id, type, hideTooltips = false) {
            let pointsMarkers = [];

            points = points
                .filter(point => {
                    if (!point.latlng) {
                        console.warn('createTrackPoints - no latlng', {latlng: null, ...point})
                    }
                    return point.latlng
                })
                .map(point => {
                    let iconName = 'map__pin-' + (point['sub-type'] ? point['sub-type'].toLocaleLowerCase().replace(' ', '-') : point.type)
                    let options = {
                        icon: {
                            assetPath: '/img/track/' + (validPictures.includes(iconName) ? iconName : 'map__pin-warning') + '.png',
                            anchorK: [0.5, 1],
                        },
                        popup: {
                            anchorK: [0, -1]
                        },
                        tooltip: {
                            anchorK: [0, -1]
                        },
                        meta: {
                            timestamp: point.time.utc,
                            duration: point.duration,
                            time: point.time.formated['time-s'],
                            // timeFrom: el.time_start.utc,
                            // timeTo: el.time_end.utc,
                            eventType: point.type,
                            xid: point.xid,
                            type: point['sub-type'] ? point.type + '.' + point['sub-type'] : point.type,
                            label: '' + point.time.formated['time-s'] + ' / ' + (point.message || point.text),
                        }
                    };
                    return this.createMarker(point.latlng, options)
                })

            Promise.all(points)
                .then(markers => {
                    markers
                        .filter(marker => !!marker)
                        .forEach(marker => {
                            // pointsMarkers.push(marker);
                            if (!hideTooltips) {
                                marker.bindTooltip(marker?.meta?.label, {
                                    permanent: true,
                                    direction: 'bottom',
                                    className: 'track-point'
                                });
                            } else {
                                marker.bindPopup(marker?.meta?.label)
                                marker.on('click', (e) => {
                                    // if(this.$isDevelopment) console.log(this.eventMarkerOnTrack)
                                    let eventType = e.target.meta.eventType
                                    let xid = e.target.meta.xid

                                    this.setRoute.trackEvent(this.$route, this.$router, eventType, xid)
                                    e.target.openPopup()
                                })
                            }
                        })

                    pointsMarkers.push(...markers)
                    let pointsMarkersObj = {
                        layers: pointsMarkers,
                        type: 'control' + '-' + type,
                        id: id
                    }
                    this.trackEventsPointsGroup.push(pointsMarkersObj);
                    if (this.trackControlPointsLayerCluster) {
                        // this.trackControlPointsLayerCluster.addLayers(pointsMarkers);
                        pointsMarkers.forEach((marker) => {
                            this.trackControlPointsLayerCluster.addLayer(marker)
                        })
                    }
                })
        },
        async updateUnitTrack() {
            // if(this.$isDevelopment) console.log('updateUnitTrack', this.track)
            if (this.trackLayer) {//remove markers
                this.trackPathLayer.removeLayer(this.trackLayer)
                this.trackLayer = null

                this.trackMarkers.forEach((marker) => {
                    this.trackPathLayer.removeLayer(marker)
                })
                this.trackMarkers = []

                this.trackEventsPointsGroup.forEach((g) => {
                    //this.trackControlPointsLayerCluster.removeLayers(g.layers);
                    [...g.layers].forEach((layer) => {
                        this.trackControlPointsLayerCluster.removeLayer(layer)
                    })
                })
                this.trackEventsPointsGroup = []
            }
            {//remove
                //this.clearTrack(params.unitId);
                {
                    //this.clearMarkers('stop', false, unitId + '_');
                    //this.clearMarkers('parking', false, unitId + '_');
                    //this.clearMarkers('startFinish', false, unitId + '_');
                    // if (this.tracks[i].popup) {
                    //     this.trackPathLayer.removeLayer(this.tracks[i].popup.layer);
                    // }
                    // this.trackPathLayer.removeLayer(this.tracks[i].layer);
                    // this.clearTrackControlPoints(unitId);
                    // this.clearEventsPoints(unitId);
                    // this.clearTrackDecorator(unitId);
                    // this.methods.clearManeuverMarkers(unitId);
                    // {
                    //     this.trackManeuverLayerCluster.removeLayers(this.trackManeuversPointsGroup[i].layers);
                    // }
                    // this.methods.clearIdleMarkers(unitId);
                    // {
                    //     this.trackIdleLayerCluster.removeLayers(this.trackIdlePointsGroup[i].layers);
                    // }
                    // this.clearMarkers('startFinish', unitId, false);
                }
                //this.clearMarkers('parking');
                //this.clearMarkers('stop');
            }
            if (!this.track) return false;
            let track = {...this.track}

            //let detail = false//track.params.detail
            if (track?.trackObjects?.length) {
                if (!track?.msgs?.length) {
                    this.toast.error(this.$t("No messages"))
                    return false;
                }

                // let latlngs = track.msgs.map(msg => (toRaw(msg.latlng)));
                // this.mapLeafletObject.fitBounds((latlngs), {
                //     paddingTopLeft: [100, 100],
                //     paddingBottomRight: [100, 200],
                //     // padding: [50, 50]
                // })

                let _track = this.createTrack(track.trackObjects[0], track.unit_id, track.msgs);
                if (_track === false) {
                    this.toast.error(this.$t("Not enough points for the track"))
                    return false;
                }

                this.trackLayer = _track.layer
                this.updateUnitSpeedColor()
                //this.mapLeafletObject.fitBounds(track.layer.getBounds());
                this.trackPathLayer.addLayer(_track.layer)
                let paddingBounds = this.getMapPaddingBounds || this.$consts.components.map.paddingBounds
                this.mapLeafletObject.fitBounds(_track.layer.getBounds(), paddingBounds)

                // create A B marker
                if (track?.msgs?.length > 1) {
                    let marker, msg, options

                    //start A
                    msg = track.msgs[0]
                    options = {
                        icon: {
                            assetPath: '/img/track/map__pin-a-point.png',
                            anchorK: [0.5, 1],
                        },
                    }
                    marker = await this.createMarker(msg.latlng, options)
                    if (marker) {
                        marker.meta = {
                            sUniqueKey: track.unit_id + '_start'
                        }
                        marker.addTo(this.trackPathLayer)
                        this.trackMarkers.push(marker)
                    }

                    //finish B
                    msg = track.msgs[track.msgs.length - 1]
                    options = {
                        icon: {
                            assetPath: '/img/track/map__pin-b-point.png',
                            anchorK: [0.5, 1],
                        },
                    }
                    marker = await this.createMarker(msg.latlng, options)
                    if (marker) {
                        marker.meta = {
                            sUniqueKey: track.unit_id + '_finish'
                        }
                        marker.addTo(this.trackPathLayer)
                        this.trackMarkers.push(marker)
                    }

                    this.trackMarkers.forEach(m => {
                        m.on('click', () => {
                            let paddingBounds = this.getMapPaddingBounds || this.$consts.components.map.paddingBounds
                            this.mapLeafletObject.fitBounds(this.trackLatLngs, paddingBounds)
                        })
                    })
                }
            }
        },
        unitMoveOnTrack() {
            let track = this.getTracks.find(t => {
                return t.timeFrom == (+this.timeFrom) && t.timeTo == (+this.timeTo)
            })
            if (!track) {
                console.error('track.msgs not found')
                return
            }
            // track = track.msgs.reduce((track, msg) => {
            //     track.push({latlng: msg.latlng, course: msg.course})
            //     return track
            // }, [])
            let options = this.getUnitsMarkersOptionsByIds[this.track.unit_id]

            //if(this.$isDevelopment) console.log('unitMoveOnTrack', track, options)
            if (this.trackUnitMarker) {
                if (this.trackUnitMarkerInterval) {
                    clearInterval(this.trackUnitMarkerInterval)
                    this.trackUnitMarkerInterval = null
                }
                this.moveOnTrackLayer.removeLayer(this.trackUnitMarker)
                this.trackUnitMarker = null
            }
            this.trackUnitMarker =
                // new DriftMarker(track.msgs[0].latlng, { icon: this.unitIcon })
                L_movingMarker([track.msgs[0].latlng], 0, {icon: this.unitIcon, autostart: false})
            // this.L.marker(track.msgs[0].latlng, { icon: this.unitIcon })
            // this.L.animatedMarker(track.msgs[0].latlng, { icon: this.unitIcon,
            //     // distance: 500,  // meters
            //     // interval: 1000, // milliseconds
            // })
            options.styleIcon.transform = 'rotate(0deg)';
            let icon = this.unitIconByType(options, true);
            //html.getElementsByClassName('unit-marker-label')[0].style.display = 'none'
            // let course = Math.round(parseInt(track.msgs[0].course)/5)*5
            this.trackUnitMarker.setIcon(icon);
            this.trackUnitMarker.addTo(this.moveOnTrackLayer)
            // this.trackLayer.addLayer(this.trackUnitMarker)

            let msgs = track.msgs.slice(1);
            if (this.trackUnitMarkerInterval) clearInterval(this.trackUnitMarkerInterval)
            this.trackUnitMarkerInterval = setInterval(() => {
                if (!msgs.length || !this.trackUnitMarker) {
                    clearInterval(this.trackUnitMarkerInterval)
                    this.trackUnitMarkerInterval = null
                    setTimeout(() => this.setRoute.trackMoveOnTrack(this.$route, this.$router, null), 500);
                    return
                }
                if (this.trackUnitMarker.isRunning()) return;
                if (this.trackUnitMarker.isPaused()) {
                    console.warn('trackUnitMarker.isPaused')
                    return;
                }

                let point = msgs.shift();
                // let course = Math.round(parseInt(point.course)/5)*5
                let p1 = this.trackUnitMarker.getLatLng()
                let p2 = this.L.latLng(point.latlng)
                let _lng = p2.lng - p1.lng
                let _lat = p2.lat - p1.lat
                let course = ((Math.atan2((_lng), (_lat))) * (180 / Math.PI) / 5) * 5
                course += course < 0 ? 360 : 0;
                // if(this.$isDevelopment) console.log("course",course,point.course)
                let html = this.trackUnitMarker.getElement()
                // let svg = html.getElementsByClassName('unit-marker-svg-icon')[0]
                // elem = elem.querySelector('.svg-icon-unit-marker')
                let svg = html.getElementsByClassName('svg-icon-unit-marker')[0]
                svg.style.transform = 'rotate(' + course + 'deg)'

                let d = Math.sqrt((Math.pow((_lat * 100000 / 1.112), 2)) + (Math.pow((_lng * 100000 / 1.112), 2)))
                d = d * 5 / this.unitMoveOnTrackSpeed
                let duration = Math.round(d / 100) * 100
                this.trackUnitMarker.moveTo(point.latlng, duration)
            }, 100);
        },
        updateUnitSpeedColor() {
            if (this.trackLayer) {
                if (this.showUnitTrackColor) {
                    this.trackLayer.eachLayer(function (layer) {
                        if (layer.getElement && typeof layer.getElement == 'function') {
                            let classList = layer.getElement()?.classList
                            if (classList) {
                                layer.getElement().classList.remove('track-layer-color-none')
                                layer.getElement().classList.add('track-layer-color')
                            }
                        }
                    });
                } else {
                    this.trackLayer.eachLayer(function (layer) {
                        if (layer.getElement && typeof layer.getElement == 'function') {
                            let classList = layer.getElement()?.classList
                            if (classList) {
                                layer.getElement().classList.add('track-layer-color-none')
                                layer.getElement().classList.remove('track-layer-color')
                            }
                        }
                    });
                }
            }
        },
        async updateUnitParked() {
            // if(this.$isDevelopment) console.log('updateUnitParked', this.parked)
            if (this.parkedLayer) {//remove markers
                this.trackPathLayer.removeLayer(this.parkedLayer)
                this.parkedLayer = null
            }
            if (this.parkedMarker) {//remove markers
                this.trackPathLayer.removeLayer(this.parkedMarker)
                this.parkedMarker = null
            }
            let coord_start = this.parked?.coord_start
            if (!coord_start?.length && !coord_start?.lat && !coord_start?.lng) return false;

            let paddingBounds = this.getMapPaddingBounds // || this.$consts.components.map.paddingBounds
            if(paddingBounds) {
                this.mapLeafletObject.fitBounds([coord_start], paddingBounds)
            } else {
                this.mapLeafletObject.setView(coord_start, 15)
            }
            // let markers = this.createTrackPoints([this.parked], this.parked.unit_id, 'parking');
            // this.parkedMarker = markers[0]
            // this.trackPathLayer.addLayer(this.parkedMarker)
            // this.trackPathLayer.fitBounds([this.parked.coord_start], { padding: [50, 50] })
            // let popup = ''+
            //     '<div class="popup-content__table-content">' +
            //     '<table class="popup-content__table">' +
            //     '<tr>' +
            //     '<td colspan="2">'+'Parking'+'</td>' +
            //     '</tr>' +
            //     '<tr>' +
            //     '<td>'+this.$t('text.Time')+':</td>' +
            //     '<td>'+this.parked.time_start.formated['time-s']+'</td>' +
            //     '</tr>' +
            //     '<tr>' +
            //     '<td>'+this.$t('text.Duration')+':</td>' +
            //     '<td>' + this.parked.duration.formated + '</td>' +
            //     '</tr>' +
            //     '</table>' +
            //     '</div>'
            let options = {
                icon: {
                    assetPath: '/img/track/map__pin-parking.png',
                    anchorK: [0.5, 1],
                },
                popup: {
                    text: '',
                    anchorK: [0, -1]
                },
                meta: {
                    sUniqueKey: this.parked.unit_id + '_parking',
                    popup: {
                        content: this.$t('popup.{time} - {event}: {duration}', {
                            time: this.parked.time_start.formated['time-s'],
                            event: this.$t('text.Parking'),
                            duration: this.parked.duration.formated
                        }),
                        className: 'startFinish-popup'
                    },
                }
            }

            let marker = await this.createMarker(this.parked.coord_start, options)
            if (marker) {
                if (marker?.meta?.popup) {
                    marker.bindPopup(marker.meta.popup?.content, {className: marker.meta.popup?.className});
                }
                this.parkedMarker = marker
                if (this.parkedMarker) this.trackPathLayer.addLayer(this.parkedMarker)
                this.parkedMarker.openPopup()
            }
        },
        async updateEventsMarkers(type, events){
            let group = this.trackEventsPointsGroup?.find(gr => gr.type == 'control-' + type)
            let markersXid = group?.layers?.filter(m => m.meta.xid) || [];
            let newEvents = events?.filter(e => !markersXid.includes(e.xid))
            if (newEvents?.length && this.track?.unit_id && !this.hideEvents) {
                this.createTrackPoints(newEvents, this.track.unit_id, type, true)
            }
        },
        onReady() {
            this.trackControlPointsLayerCluster = // new MarkerClusterGroup(this.trackClusterOptions);
                this.$refs.trackCluster.leafletObject
            this.tracksLayer = this.$refs.tracksLayer.leafletObject
            this.trackPathLayer = this.$refs.trackPathLayer.leafletObject
            this.moveOnTrackLayer = this.$refs.moveOnTrackLayer.leafletObject
            // this.trackControlPointsLayerCluster.on('clusterclick', (a) => {
            //     a.layer.zoomToBounds();
            //     // if(this.$isDevelopment) console.log('click cluster')
            // })
            // this.trackPathLayer.addLayer(this.trackControlPointsLayerCluster)
        },
    },
    created() {
        this.debouncedUpdateEventsMarkers = debounce(() => {
            this.updateEventsMarkers('event', this.events)
        }, 300)
        this.debouncedUpdateVideoEventsMarkers = debounce(() => {
            this.updateEventsMarkers('video-events', this.videoEvents)
        }, 300)
        this.debouncedUpdateStopsMarkers = debounce(() => {
            this.updateEventsMarkers('stop', this.stops)
        }, 300)
        this.debouncedUpdateUnitTrack = debounce(() => {
            this.updateUnitTrack()
        }, 300);
        this.debouncedUpdateUnitParked = debounce(() => {
            this.updateUnitParked()
        }, 300);
        this.debouncedUpdateSpeedActive = debounce(() => {
            this.updateUnitSpeedColor()
        }, 300);
    },
    mounted() {
    },
    updated() {
        if(this.$isDevelopment) console.log('updated', this._.type.name)
    },
    beforeUnmount() {
    }
}
</script>

<style scoped>

</style>